import React, { useEffect, useState } from 'react';
import { Header, Footer, LeftMenu } from '../commons/components';
import { Content } from './components';
import { usePageSettingHeaderStore } from '../commons/stores';
import { Link } from 'react-router-dom';
import { AddThemeContent } from './components';
import { useParams } from 'react-router-dom';
import 'react-simple-hook-modal/dist/styles.css';
import axios from 'axios';
import {
  ModalProvider,
  Modal,
  useModal,
  ModalTransition,
} from 'react-simple-hook-modal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FileBase from 'react-file-base64';

export default function Home() {
  const [statePageSettingHeader] = usePageSettingHeaderStore();
  const { isModalOpen, openModal, closeModal } = useModal();

  const [loadImage, setLoadImage] = useState();
  console.log('ini image get', loadImage);

  const pull_data = (data) => {
    setDataTemplateOper(data);
    console.log('ini data each', data.paperColor);
  };

  let contentUi = <div className='loader-block' />;
  // if (!dataThemeOper.isLoading) {
    contentUi = (
      <React.Fragment>
        <AddThemeContent func={pull_data}/>
      </React.Fragment>
    );
  // }

   const [dataTemplateOper, setDataTemplateOper] = useState([]);

  const commitToDB = () => {
    console.log('button save diklik');
    const data = {
      // dataTemplateOper
      templateName: templateName,
      docName: docName,
      docDesc: docDesc,
      questions: dataTemplateOper,
      theme: newTheme,
      type: templateType,
      selectedFile : templateImg
    };
    console.log('post : ', data);
    axios
      .post(`https://apiubaforms.herokuapp.com/api/v1/add-template`, {
        ...data,
      })
      .then((response, error) => {
        if (error) {
          response.status(400).send({ message: error.err });
          toast.warning({ message: error.err });
        }
        if (!error) {
          toast.success(response.data.message);
          console.log(response.data.message);
        }
      });
  };

  const [templateName, setTemplateName] = useState("")
  const [docName, setDocName] = useState('')
  const [docDesc, setDocDesc] = useState('')
  const [templateType, setTemplateType] = useState('')
  const [templateImg, setTemplateImg] = useState('')

  const option = ['FORMS', 'SURVEY', 'QUIZ'];

  const handleChangeTemplateName = (e) => {
    setTemplateName(e.target.value);
  };
  const handleChangeDocName = (e) => {
    setDocName(e.target.value);
  };
  const handleChangeDocDesc = (e) => {
    setDocDesc(e.target.value);
  };

  const Types = option.map((Type) => Type);
  const handleTypeChange = (e) => {
    console.log(templateType[e.target.value]);
    setTemplateType(option[e.target.value]);
  };

  const [newTheme, setNewTheme] = useState({
    fontType: 'Poppins',
    paperColor: '#FFFFFF',
    backgroundPaperColor: '#FFFFFF',
    backgroundImagePaperColor: ``,
    questionColor: '#000000',
    answerColor: '#000000',
    stripColor:'#000000',
    backgroundButtonColor: '#FEFEFE',
  });
  
  return (
    <>
    <ToastContainer/>
    <div className='App'>
      <Header />
      {statePageSettingHeader.leftMenu ? <LeftMenu /> : null}

      <main className='workspace'>
        <section className='breadcrumb lg:flex items-start'>
          <div>
            <h1>Add New Template</h1>
            <ul>
              <li>
                <Link to='/template-management'>Template</Link>
              </li>

              <li className='divider la la-arrow-right'></li>
              <li>Add New Template</li>
            </ul>
          </div>
          <div className='lg:flex items-center ml-auto mt-5 lg:mt-0'>
            <div className='flex mt-5 lg:mt-0'>
              <button
                // to={`/theme-management/add/${id}`}
                onClick={openModal}
                // onClick={pull_data()}
                // onClick={commitToDB}
                className='mr-3 bg-primary text-white font-semibold py-2 px-4 border border-grey-500 rounded'
              >
                Publish template
              </button>
              <Link
                to='/template-management'
                className='bg-transparent text-primary font-semibold py-2 px-4 border border-grey-500 rounded'
              >
                Back to list
              </Link>
            </div>
          </div>
        </section>

        <ModalProvider>
          {/* <MyComponent /> */}
          <Modal
            id='any-unique-identifier'
            isOpen={isModalOpen}
            transition={ModalTransition.SCALE}
          >
            <form
              // className='w-full max-w-lg justify-center'
              onSubmit={commitToDB}
            >

              <div className='sm:grid-cols-2 grid sm:gap-7 gap-3 mt-6'>  
                <div className=' overflow-hidden rounded-lg'>
                  
                    <div className='w-full py-3'>
                      <label
                        className='block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2'
                        for='template-name'
                      >
                        Enter Template Name
                      </label>
                      <input
                        className='appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                        id='template-name'
                        type='text'
                        placeholder='Registration template'
                        // required={true}
                        name='name'
                        value={templateName}
                        onChange={handleChangeTemplateName}
                      />
                    </div>
                    <div className='w-full py-3'>
                      <label
                        className='block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2'
                        for='doc-name'
                      >
                        Enter Document Name
                      </label>
                      <input
                        className='appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                        id='doc-name'
                        type='text'
                        placeholder='Registration exams'
                        // required={true}
                        name='name'
                        value={docName}
                        onChange={handleChangeDocName}
                      />
                    </div>
                    <div className='w-full pt-3'>
                      <label
                        className='block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2'
                        for='template-description'
                      >
                        Enter Template Description
                      </label>
                      <textarea
                        className='appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                        id='template-description'
                        type='text'
                        placeholder='Great template for make your easy to build'
                        rows={6}
                        value={docDesc}
                        onChange={handleChangeDocDesc}
                        // required
                      />
                    </div>
                    <div className='w-full py-10'>
                      <label
                        className='block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2'
                        for='grid-state'
                      >
                        Chose Template's Type
                      </label>
                      <div className='relative'>
                        <select
                          className='block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                          id='grid-state'
                          onChange={(e) => handleTypeChange(e)}
                          // required
                        >
                          {Types.map((address, key) => (
                            <option value={key}>{address}</option>
                          ))}
                        </select>
                        <div className='pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700'>
                          <svg
                            className='fill-current h-4 w-4'
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 20 20'
                          >
                            <path d='M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z' />
                          </svg>
                        </div>
                      </div>
                    </div>
                 
                </div>
           
               
                <div className='overflow-hidden rounded-lg '>
                  
                    <div className='mt-2 flex flex-col'>
                      
                        <FileBase
                          type='file'
                          className='hidden'
                          multiple={false}
                          onDone={({ base64 }) =>
                            setTemplateImg(base64)
                          }
                        />
                                         
                      
                      <img src={templateImg} />
                      {/* <p>{templateImg}</p> */}
                    </div>
                 
                </div>
              </div>
            </form>
            <div className='flex mt-5 lg:mt-0'>
              <button
                // type='submit'
                onClick={commitToDB}
                className='mr-3 bg-primary text-white font-semibold py-2 px-4 border border-grey-500 rounded'
              >
                Save template
              </button>
              <button
                onClick={closeModal}
                className='bg-transparent text-red-500 font-semibold py-2 px-4 border border-grey-500 rounded'
              >
                Cancel
              </button>
            </div>
          </Modal>
        </ModalProvider>

        {contentUi}

        <Footer />
      </main>
    </div>
    </>
  );
}
